import { Box } from '@factorialco/deprecated-design-system'
import { CardDetailFragment, CardPaymentCategoryFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ApprovalsInformationBlock from 'modules/approvals/components/ApprovalsInformationBlock'
import StripeWrapper from 'modules/expenses/components/cards/StripeWrapper'

import { ActivateCard } from './_ActivateCard'
import { CardDetails } from './_CardDetails'
import { CardTabs } from './_CardTabs'
import { CardTrackInfo } from './_CardTrackInfo'
import { Header } from './_Header'
import { RejectionReason } from './_RejectionReason'
import { SidebarSection } from './_SidebarSection'

export const Content: React.FC<{
  card: CardDetailFragment
  cardPaymentCategories: CardPaymentCategoryFragment[]
  skipCardControlsCategories: boolean
  canManageCards: boolean
}> = ({ card, skipCardControlsCategories, canManageCards, cardPaymentCategories }) => {
  const { navigation } = useNavigation()
  return (
    <StripeWrapper
      stripeAccount={card.externalAccountId}
      redirectIfFailRoute={navigation.finance.cards.fullPath()}
    >
      <Box gap="s32" paddingRight="s8">
        <SidebarSection>
          <Header card={card} />
          <Box gap="s24" width="full" alignItems="center">
            <RejectionReason card={card} />
            <CardDetails card={card} />
          </Box>
        </SidebarSection>

        {card.approval && (
          <ApprovalsInformationBlock
            resourceId={card.approval.resourceId}
            resourceType={card.approval.resourceType}
          />
        )}

        <Box gap="s24">
          <CardTrackInfo card={card} canManageCards={canManageCards} />
          <ActivateCard card={card} />
          <CardTabs
            cardPaymentCategories={cardPaymentCategories}
            card={card}
            skipCardControlsCategories={skipCardControlsCategories}
          />
        </Box>
      </Box>
    </StripeWrapper>
  )
}
